// GENERATED by scripts/gen-art-v2.mts — do not edit.
// Every frame the painted v2 theme carries, and the format they were written in. A name
// absent here keeps its v1 vector art, which is what lets the theme cover what it covers.
export const V2_EXT = 'webp'
export const V2_FRAMES: ReadonlySet<string> = new Set([
  'characters/person/parts/courier/arm_l_l',
  'characters/person/parts/courier/arm_l_r',
  'characters/person/parts/courier/arm_u_l',
  'characters/person/parts/courier/arm_u_r',
  'characters/person/parts/courier/foot_l',
  'characters/person/parts/courier/foot_r',
  'characters/person/parts/courier/hair',
  'characters/person/parts/courier/hand_l',
  'characters/person/parts/courier/hand_r',
  'characters/person/parts/courier/head',
  'characters/person/parts/courier/leg_l_l',
  'characters/person/parts/courier/leg_l_r',
  'characters/person/parts/courier/leg_u_l',
  'characters/person/parts/courier/leg_u_r',
  'characters/person/parts/courier/prop',
  'characters/person/parts/courier/prop2',
  'characters/person/parts/courier/torso',
  'characters/person/parts/dogwalker/arm_l_l',
  'characters/person/parts/dogwalker/arm_l_r',
  'characters/person/parts/dogwalker/arm_u_l',
  'characters/person/parts/dogwalker/arm_u_r',
  'characters/person/parts/dogwalker/foot_l',
  'characters/person/parts/dogwalker/foot_r',
  'characters/person/parts/dogwalker/hair',
  'characters/person/parts/dogwalker/hand_l',
  'characters/person/parts/dogwalker/hand_r',
  'characters/person/parts/dogwalker/head',
  'characters/person/parts/dogwalker/leg_l_l',
  'characters/person/parts/dogwalker/leg_l_r',
  'characters/person/parts/dogwalker/leg_u_l',
  'characters/person/parts/dogwalker/leg_u_r',
  'characters/person/parts/dogwalker/prop',
  'characters/person/parts/dogwalker/prop2',
  'characters/person/parts/dogwalker/torso',
  'characters/person/parts/kid/arm_l_l',
  'characters/person/parts/kid/arm_l_r',
  'characters/person/parts/kid/arm_u_l',
  'characters/person/parts/kid/arm_u_r',
  'characters/person/parts/kid/foot_l',
  'characters/person/parts/kid/foot_r',
  'characters/person/parts/kid/hair',
  'characters/person/parts/kid/hand_l',
  'characters/person/parts/kid/hand_r',
  'characters/person/parts/kid/head',
  'characters/person/parts/kid/leg_l_l',
  'characters/person/parts/kid/leg_l_r',
  'characters/person/parts/kid/leg_u_l',
  'characters/person/parts/kid/leg_u_r',
  'characters/person/parts/kid/prop',
  'characters/person/parts/kid/prop2',
  'characters/person/parts/kid/torso',
  'characters/person/parts/sitter/arm_l_l',
  'characters/person/parts/sitter/arm_l_r',
  'characters/person/parts/sitter/arm_u_l',
  'characters/person/parts/sitter/arm_u_r',
  'characters/person/parts/sitter/foot_l',
  'characters/person/parts/sitter/foot_r',
  'characters/person/parts/sitter/hair',
  'characters/person/parts/sitter/hand_l',
  'characters/person/parts/sitter/hand_r',
  'characters/person/parts/sitter/head',
  'characters/person/parts/sitter/leg_l_l',
  'characters/person/parts/sitter/leg_l_r',
  'characters/person/parts/sitter/leg_u_l',
  'characters/person/parts/sitter/leg_u_r',
  'characters/person/parts/sitter/prop',
  'characters/person/parts/sitter/prop2',
  'characters/person/parts/sitter/torso',
  'characters/person/parts/walker_a/arm_l_l',
  'characters/person/parts/walker_a/arm_l_r',
  'characters/person/parts/walker_a/arm_u_l',
  'characters/person/parts/walker_a/arm_u_r',
  'characters/person/parts/walker_a/foot_l',
  'characters/person/parts/walker_a/foot_r',
  'characters/person/parts/walker_a/hair',
  'characters/person/parts/walker_a/hand_l',
  'characters/person/parts/walker_a/hand_r',
  'characters/person/parts/walker_a/head',
  'characters/person/parts/walker_a/leg_l_l',
  'characters/person/parts/walker_a/leg_l_r',
  'characters/person/parts/walker_a/leg_u_l',
  'characters/person/parts/walker_a/leg_u_r',
  'characters/person/parts/walker_a/prop',
  'characters/person/parts/walker_a/prop2',
  'characters/person/parts/walker_a/torso',
  'characters/person/parts/walker_b/arm_l_l',
  'characters/person/parts/walker_b/arm_l_r',
  'characters/person/parts/walker_b/arm_u_l',
  'characters/person/parts/walker_b/arm_u_r',
  'characters/person/parts/walker_b/foot_l',
  'characters/person/parts/walker_b/foot_r',
  'characters/person/parts/walker_b/hair',
  'characters/person/parts/walker_b/hand_l',
  'characters/person/parts/walker_b/hand_r',
  'characters/person/parts/walker_b/head',
  'characters/person/parts/walker_b/leg_l_l',
  'characters/person/parts/walker_b/leg_l_r',
  'characters/person/parts/walker_b/leg_u_l',
  'characters/person/parts/walker_b/leg_u_r',
  'characters/person/parts/walker_b/prop',
  'characters/person/parts/walker_b/prop2',
  'characters/person/parts/walker_b/torso',
  'characters/zombie/parts/common/brow',
  'characters/zombie/parts/common/eye_l',
  'characters/zombie/parts/common/eye_r',
  'characters/zombie/parts/common/jaw',
  'characters/zombie/parts/common/lid_l',
  'characters/zombie/parts/common/lid_r',
  'characters/zombie/parts/common/placard',
  'characters/zombie/parts/hoodie/arm_l_l',
  'characters/zombie/parts/hoodie/arm_l_r',
  'characters/zombie/parts/hoodie/arm_u_l',
  'characters/zombie/parts/hoodie/arm_u_r',
  'characters/zombie/parts/hoodie/brow',
  'characters/zombie/parts/hoodie/eye_l',
  'characters/zombie/parts/hoodie/eye_r',
  'characters/zombie/parts/hoodie/foot_l',
  'characters/zombie/parts/hoodie/foot_r',
  'characters/zombie/parts/hoodie/hair',
  'characters/zombie/parts/hoodie/hand_l',
  'characters/zombie/parts/hoodie/hand_r',
  'characters/zombie/parts/hoodie/head',
  'characters/zombie/parts/hoodie/jaw',
  'characters/zombie/parts/hoodie/leg_l_l',
  'characters/zombie/parts/hoodie/leg_l_r',
  'characters/zombie/parts/hoodie/leg_u_l',
  'characters/zombie/parts/hoodie/leg_u_r',
  'characters/zombie/parts/hoodie/lid_l',
  'characters/zombie/parts/hoodie/lid_r',
  'characters/zombie/parts/hoodie/prop',
  'characters/zombie/parts/hoodie/torso',
  'characters/zombie/parts/intern/arm_l_l',
  'characters/zombie/parts/intern/arm_l_r',
  'characters/zombie/parts/intern/arm_u_l',
  'characters/zombie/parts/intern/arm_u_r',
  'characters/zombie/parts/intern/brow',
  'characters/zombie/parts/intern/eye_l',
  'characters/zombie/parts/intern/eye_r',
  'characters/zombie/parts/intern/foot_l',
  'characters/zombie/parts/intern/foot_r',
  'characters/zombie/parts/intern/hair',
  'characters/zombie/parts/intern/hand_l',
  'characters/zombie/parts/intern/hand_r',
  'characters/zombie/parts/intern/head',
  'characters/zombie/parts/intern/jaw',
  'characters/zombie/parts/intern/leg_l_l',
  'characters/zombie/parts/intern/leg_l_r',
  'characters/zombie/parts/intern/leg_u_l',
  'characters/zombie/parts/intern/leg_u_r',
  'characters/zombie/parts/intern/lid_l',
  'characters/zombie/parts/intern/lid_r',
  'characters/zombie/parts/intern/prop',
  'characters/zombie/parts/intern/torso',
  'characters/zombie/parts/office/arm_l_l',
  'characters/zombie/parts/office/arm_l_r',
  'characters/zombie/parts/office/arm_u_l',
  'characters/zombie/parts/office/arm_u_r',
  'characters/zombie/parts/office/brow',
  'characters/zombie/parts/office/eye_l',
  'characters/zombie/parts/office/eye_r',
  'characters/zombie/parts/office/foot_l',
  'characters/zombie/parts/office/foot_r',
  'characters/zombie/parts/office/hair',
  'characters/zombie/parts/office/hand_l',
  'characters/zombie/parts/office/hand_r',
  'characters/zombie/parts/office/head',
  'characters/zombie/parts/office/jaw',
  'characters/zombie/parts/office/leg_l_l',
  'characters/zombie/parts/office/leg_l_r',
  'characters/zombie/parts/office/leg_u_l',
  'characters/zombie/parts/office/leg_u_r',
  'characters/zombie/parts/office/lid_l',
  'characters/zombie/parts/office/lid_r',
  'characters/zombie/parts/office/prop',
  'characters/zombie/parts/office/torso',
  'characters/zombie/parts/suit/arm_l_l',
  'characters/zombie/parts/suit/arm_l_r',
  'characters/zombie/parts/suit/arm_u_l',
  'characters/zombie/parts/suit/arm_u_r',
  'characters/zombie/parts/suit/brow',
  'characters/zombie/parts/suit/eye_l',
  'characters/zombie/parts/suit/eye_r',
  'characters/zombie/parts/suit/foot_l',
  'characters/zombie/parts/suit/foot_r',
  'characters/zombie/parts/suit/hair',
  'characters/zombie/parts/suit/hand_l',
  'characters/zombie/parts/suit/hand_r',
  'characters/zombie/parts/suit/head',
  'characters/zombie/parts/suit/jaw',
  'characters/zombie/parts/suit/leg_l_l',
  'characters/zombie/parts/suit/leg_l_r',
  'characters/zombie/parts/suit/leg_u_l',
  'characters/zombie/parts/suit/leg_u_r',
  'characters/zombie/parts/suit/lid_l',
  'characters/zombie/parts/suit/lid_r',
  'characters/zombie/parts/suit/prop',
  'characters/zombie/parts/suit/torso',
  'scene/anthropic/building',
  'scene/anthropic/sign',
  'scene/anthropic/skyline',
  'scene/common/ad_sign_face',
  'scene/common/ad_sign_frame',
  'scene/common/bench',
  'scene/common/coffee_cart',
  'scene/common/gate_arch',
  'scene/common/gate_broken',
  'scene/common/gate_closed',
  'scene/common/gate_open_l',
  'scene/common/gate_open_r',
  'scene/common/gate_road',
  'scene/common/ground_tile',
  'scene/common/lamp',
  'scene/common/rubble_1',
  'scene/common/rubble_2',
  'scene/common/rubble_3',
  'scene/common/sky_day',
  'scene/common/sky_dusk',
  'scene/common/sky_night',
  'scene/common/tree_1',
  'scene/common/tree_2',
  'scene/common/wall_post',
  'scene/common/wall_seg_broken',
  'scene/common/wall_seg_cracked_1',
  'scene/common/wall_seg_cracked_2',
  'scene/common/wall_seg_intact',
  'scene/google/building',
  'scene/google/sign',
  'scene/google/skyline',
  'scene/openai/building',
  'scene/openai/hut_chimney_puff',
  'scene/openai/hut_codex',
  'scene/openai/hut_sign',
  'scene/openai/sign',
  'scene/openai/skyline',
])
